var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 16.5C4.0875 16.5 3.7345 16.3533 3.441 16.0597C3.1475 15.7662 3.0005 15.413 3 15V7.5C3 7.0875 3.147 6.7345 3.441 6.441C3.735 6.1475 4.088 6.0005 4.5 6H5.25V4.5C5.25 3.4625 5.61575 2.57825 6.34725 1.84725C7.07875 1.11625 7.963 0.7505 9 0.75C10.0375 0.75 10.922 1.11575 11.6535 1.84725C12.385 2.57875 12.7505 3.463 12.75 4.5V6H13.5C13.9125 6 14.2657 6.147 14.5597 6.441C14.8538 6.735 15.0005 7.088 15 7.5V15C15 15.4125 14.8533 15.7657 14.5597 16.0597C14.2662 16.3538 13.913 16.5005 13.5 16.5H4.5ZM9 12.75C9.4125 12.75 9.76575 12.6033 10.0598 12.3097C10.3538 12.0162 10.5005 11.663 10.5 11.25C10.5 10.8375 10.3533 10.4845 10.0598 10.191C9.76625 9.8975 9.413 9.7505 9 9.75C8.5875 9.75 8.2345 9.897 7.941 10.191C7.6475 10.485 7.5005 10.838 7.5 11.25C7.5 11.6625 7.647 12.0157 7.941 12.3097C8.235 12.6038 8.588 12.7505 9 12.75ZM6.75 6H11.25V4.5C11.25 3.875 11.0312 3.34375 10.5938 2.90625C10.1562 2.46875 9.625 2.25 9 2.25C8.375 2.25 7.84375 2.46875 7.40625 2.90625C6.96875 3.34375 6.75 3.875 6.75 4.5V6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockBlackIcon);
export default __webpack_public_path__ + "static/media/lock-black-icon.e59383a3a37a9a0005b37aab507a9094.svg";
export { ForwardRef as ReactComponent };